module.exports = __webpack_public_path__ + "static/img/chengg1@2x.4fd4f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chengg1@2x.png
// module id = KG9f
// module chunks = 1